import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5.9,
			y: 1.7,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.6,
			y: 1.7,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5.8
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M42.5 8.8v33.7h-40V8.8h40m.2-2.5H2.3C1 6.3 0 7.3 0 8.5v34.2C0 44 1 45 2.3 45h40.5c1.2 0 2.3-1 2.3-2.3V8.5C45 7.3 44 6.3 42.7 6.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M43.7 0H26.4v13.4h-7.7V0H1.4C.7 0 .1.6.1 1.3s.6 1.2 1.2 1.2h14.8v40.6c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-5.5h7.7v5.2c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2V2.5h14.8c1 0 1.6-.5 1.6-1.2S44.4 0 43.7 0zM26.4 16v4.8h-7.7V16h7.7zm0 7.2V28h-7.7v-4.8h7.7zm-7.8 12v-4.8h7.7v4.8h-7.7z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.1,
			y: 42.5,
			className: "icon-fill-primary",
			width: 29.4,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M7.1 16.8c-.7 0-1.2-.6-1.2-1.2v-2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v2c.1.7-.5 1.2-1.2 1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M7.1 34.9c-.7 0-1.2-.6-1.2-1.2v-13c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v13c.1.7-.5 1.2-1.2 1.2z"
		})
	]
});
export default SvgIcon;
